import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class CostDocumentItemSettlement {
  @IsNumber()
  @Expose()
  costDocumentItemId!: number;
  @IsBoolean()
  @Expose()
  differentCurrencies!: boolean;
  @IsString()
  @Expose()
  documentItemId!: string;
  @IsNumber()
  @Expose()
  exchangeDifference!: number;
  @IsNumber()
  @Expose()
  id!: number;
  @IsBoolean()
  @Expose()
  isCostCalculationPosition!: boolean;
  @IsNumber()
  @Expose()
  leftAmountAsExchangeDifference!: number;
  @IsNumber()
  @Expose()
  settlementAmountInCurrency!: number;
}

export class UpdateExtendPairData {
  @IsNumber()
  @Expose()
  extendPairCostDifference!: number;
  @IsOptional()
  @Type(() => CostDocumentItemSettlement)
  @ValidateNested()
  @Expose()
  costDocumentItemSettlement!: CostDocumentItemSettlement;
  @IsNumber()
  @Expose()
  costDocumentItemLeftAmount!: number;
  @IsNumber()
  @Expose()
  documentItemLeftAmount!: number;
  @IsBoolean()
  @Expose()
  isCurrencyDifferences!: boolean;
}
